const routes = {
  SIGN_IN: "/sign-in",
  HOME: "/",
  CALLBACK: "/callback",
}

export { routes }
